import loadable from "@loadable/component";
import "./map.scss";

loadable.lib(
  () => import(/* webpackChunkName: "map" */"@ct-react/map"),
  { ssr: false });

export const MapContainer = loadable(
  () => import(/* webpackChunkName: "map" */"@ct-react/map"),
  { ssr: false });

export const MapMarker = loadable(
  () => import(/* webpackChunkName: "map" */"@ct-react/map"),
  { ssr: false, resolveComponent: module => module.Marker });

export const MapPopup = loadable(
  () => import(/* webpackChunkName: "map" */"@ct-react/map"),
  { ssr: false, resolveComponent: module => module.Popup });

export const MapAsyncPopupMarker = loadable(
  () => import(/* webpackChunkName: "map" */"./async-popup-marker"),
  { ssr: false });
